import { useMobile } from "../../../hooks/useMobile";
import { useQuotationBuilder } from "./quotation/useQuotationBuilder";
import MobileQuotationBuilder from "./quotation/MobileQuotationBuilder";
import DesktopQuotationBuilder from "./quotation/DesktopQuotationBuilder";
import "./quotation/quotation.css";

// Thin wrapper that keeps the original public API (default export + props).
// All state/logic lives in useQuotationBuilder, and the device decides whether
// to render the touch-first MobileQuotationBuilder or the DesktopQuotationBuilder.
export default function QuotationBuilder(props) {
  const qb = useQuotationBuilder(props);
  const isMobile = useMobile();

  if (isMobile) {
    return <MobileQuotationBuilder qb={qb} />;
  }
  return <DesktopQuotationBuilder qb={qb} />;
}
